import styled from 'styled-components'

import COLORS from 'constants/colors'
import LAYOUT from 'constants/layout'
import MEDIA from 'constants/media'

import { Props } from './types'

export default styled.div<Props>`
  background-color: ${(props: Props): string => (props.backgroundColor ? COLORS[props.backgroundColor] : COLORS.WHITE)};
  flex: ${(props: Props): number => (props.flexSize !== undefined ? props.flexSize : 1)};
  margin-top: ${LAYOUT.VERTICALSPACEMOBILE};
  padding: ${(props: Props): string => (props.backgroundColor && props.backgroundColor !== 'WHITE' ? '20px' : '0')};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  ${MEDIA.medium`
    margin-top: ${LAYOUT.VERTICALSPACE};
  `}
`
